import React from 'react';
import { UserIcon, ChevronRightIcon, ClockIcon } from 'lucide-react';
interface TeamMemberCardProps {
  name: string;
  pendingCount: number;
  totalLoans: number;
  lastActivity: string;
  onViewLoans: () => void;
}
export function TeamMemberCard({
  name,
  pendingCount,
  totalLoans,
  lastActivity,
  onViewLoans
}: TeamMemberCardProps) {
  const completedCount = totalLoans - pendingCount;
  const progressPercent = totalLoans > 0 ? Math.round(completedCount / totalLoans * 100) : 0;
  const initials = name.split(' ').map(n => n[0]).join('').toUpperCase();
  return <button onClick={onViewLoans} className="w-full bg-white rounded-xl border border-gray-100 p-5 shadow-sm hover:shadow-md hover:border-blue-200 transition-all duration-200 text-left group focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2" aria-label={`View funded loans for ${name}`} data-id="element-149">
      <div className="flex items-start justify-between" data-id="element-150">
        <div className="flex items-center gap-3" data-id="element-151">
          <div className="flex items-center justify-center w-11 h-11 rounded-full bg-blue-600 text-white text-sm font-semibold flex-shrink-0" data-id="element-152">
            {initials}
          </div>
          <div data-id="element-153">
            <h3 className="text-sm font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-154">
              {name}
            </h3>
            <div className="flex items-center gap-1 mt-0.5" data-id="element-155">
              <ClockIcon className="w-3.5 h-3.5 text-gray-400" data-id="element-156" />
              <span className="text-xs text-gray-500" data-id="element-157">{lastActivity}</span>
            </div>
          </div>
        </div>
        <ChevronRightIcon className="w-5 h-5 text-gray-300 group-hover:text-blue-500 transition-colors mt-1" data-id="element-158" />
      </div>

      <div className="mt-4" data-id="element-159">
        <div className="flex items-center justify-between mb-1.5" data-id="element-160">
          <span className="text-xs font-medium text-gray-500" data-id="element-161">
            Follow-up progress
          </span>
          <span className="text-xs font-semibold text-gray-700" data-id="element-162">
            {completedCount}/{totalLoans}
          </span>
        </div>
        <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-163">
          <div className="h-full bg-blue-500 rounded-full transition-all duration-500" style={{
          width: `${progressPercent}%`
        }} data-id="element-164" />
        </div>
      </div>

      <div className="mt-3 flex items-center gap-2" data-id="element-165">
        {pendingCount > 0 && <span className="inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full bg-amber-50 text-amber-700 border border-amber-200" data-id="element-166">
            {pendingCount} pending
          </span>}
        {pendingCount === 0 && <span className="inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200" data-id="element-167">
            All complete
          </span>}
      </div>
    </button>;
}